import { formatIOSDateStr } from './time';
import { url } from '@tencent/ppd-base-libs';

// mock系统时间
const mockServerTime: string = url.getUrlParam('serverTime');
// 使用本地时间
const localTime: string = url.getUrlParam('localTime');
let serverTimeDiff = 0;

/**
 * 设置系统时间
 * @param inputServerTime
 */
export function setServerTime(inputServerTime: string | number) {
  if (serverTimeDiff) return;
  // 如果已赋值就返回
  let serverTime = mockServerTime || inputServerTime;

  if (typeof serverTime === 'string') {
    serverTime = formatIOSDateStr(serverTime);
  }
  serverTimeDiff = Date.now() - new Date(serverTime).getTime();
}

/**
 * 获取系统时间
 * @returns {Date}
 */
export function getServerTime(): Date {
  if (localTime === '1') return new Date();
  return new Date(Date.now() - serverTimeDiff);
}
